import { INode, NodeTypeEnum } from './model';
import { EventEmitter } from '@angular/core';

export class Node implements INode {
	parent: Node;
	NodeType: NodeTypeEnum;
	Field?: string;
	Operate?: string;
	Value?: string;
	Children?: Node[];
	PlainText?: string;
	static fromInterface(data: INode): Node {
		const rev = new Node();
		rev.NodeType = NodeTypeEnum.unknow;
		if (data) {
			rev.NodeType = data.NodeType;
			rev.Field = data.Field;
			rev.Operate = data.Operate;
			rev.Value = data.Value;
			rev.PlainText = data.PlainText;
			if (data.Children) {
				rev.Children = data.Children.map(v => {
					const n = Node.fromInterface(v);
					n.parent = rev;
					return n;
				});
			}
		}
		return rev;
	}
	assign(src: INode) {
		this.NodeType = src.NodeType;
		this.Field = src.Field;
		this.Operate = src.Operate;
		this.Value = src.Value;
		this.PlainText = src.PlainText;
		if (src.Children) {
			this.Children = src.Children.map(v => {
				const rev = Node.fromInterface(v);
				rev.parent = this;
				return rev;
			});
		}
	}
	toInterface(): INode {
		// empty node
		if (this.NodeType === NodeTypeEnum.unknow) {
			return null;
		}
		const rev: INode = {
			NodeType: this.NodeType,
			Field: this.Field,
			Operate: this.Operate,
			Value: this.Value,
			PlainText: this.PlainText
		};
		if (this.Children) {
			rev.Children = this.Children.map(v => v.toInterface());
		}
		return rev;
	}
	insertChild(index: number, node: INode) {
		this.Children = this.Children || [];
		const n = Node.fromInterface(node);
		n.parent = this;
		if (index >= this.Children.length) {
			this.Children.push(n);
		} else {
			this.Children.splice(index, 0, n);
		}
	}
	replaceChild(node: Node, newNode: Node) {
		newNode.parent = this;
		this.Children.splice(this.Children.findIndex(v => v === node), 1, newNode);
	}
	// æ·»å åå¼ï¼å¨å½åèç¹ä¹ä¸
	addTopSibling(node: INode) {
		if (!this.parent) {
			this.addChildSibling(node);
			return;
		}
		this.parent.insertChild(this.parent.Children.findIndex(v => v === this), node);
	}
	// æ·»å åå¼ï¼å¨å½åèç¹ä¹ä¸
	addBottomSibling(node: INode) {
		if (!this.parent) {
			this.addChildSibling(node);
			return;
		}
		this.parent.insertChild(this.parent.Children.findIndex(v => v === this) + 1, node);
	}
	// å½åèç¹åè¯¥èç¹å½¢æä¸ä¸ªæ°çandèç¹ï¼åä»£å½åèç¹çä½ç½®
	addChildSibling(node: INode) {
		if (this.parent) {
			const andNode = Node.fromInterface({ NodeType: NodeTypeEnum.NodeAnd });
			andNode.insertChild(0, node);
			this.parent.replaceChild(this, andNode);
			andNode.insertChild(0, this);
		} else {
			// å¦æåªæä¸ä¸ªæ¡ä»¶èç¹ï¼åéè¦å¯¹åå®¹è¿è¡æ¿æ¢ï¼å ä¸ºç»ä»¶å¼ç¨ç¨å°æ¯æé
			const newThis = Node.fromInterface({
				NodeType: this.NodeType,
				Field: this.Field,
				Operate: this.Operate,
				Value: this.Value,
				PlainText: this.PlainText
			});
			newThis.parent = this;
			this.NodeType = NodeTypeEnum.NodeAnd;
			this.Field = undefined;
			this.Operate = undefined;
			this.Value = undefined;
			this.PlainText = undefined;
			this.Children = [newThis];
			this.insertChild(1, node);
		}
	}
	// è¿åæå¹³ååçæ»ä½é«åº¦ï¼æ¯ä¸ªå­èç¹ç®1
	flatHeight(): number {
		if (NodeTypeEnum.NodeCondition === this.NodeType || NodeTypeEnum.NodePlain === this.NodeType) {
			return 1;
		}
		let rev = 0;
		if (this.Children) {
			this.Children.forEach(v => (rev += v.flatHeight()));
		}
		return rev;
	}
	// æ¶éåèç¹ï¼æåå°ä¸çº§
	collection() {
		if (!this.Children) {
			return;
		}
		if (this.Children.length === 1) {
			this.NodeType = this.Children[0].NodeType;
			this.Field = this.Children[0].Field;
			this.Operate = this.Children[0].Operate;
			this.Value = this.Children[0].Value;
			this.PlainText = this.Children[0].PlainText;
			this.Children = this.Children[0].Children;
			this.collection();
		} else {
			this.Children.forEach(v => v.collection());
		}
	}
	findRoot() {
		let find: Node;
		for (find = this; find.parent; find = find.parent) {}
		return find;
	}
	removeChild(node: Node) {
		if (this.Children.length > 1) {
			this.Children.splice(this.Children.findIndex(v => v === node), 1);
			// rootå¼å§æ£æ¥ï¼æåå°ä¸çº§
			this.findRoot().collection();
		} else {
			if (this.parent) {
				this.parent.removeChild(this);
			} else {
				this.NodeType = NodeTypeEnum.unknow;
				this.Field = undefined;
				this.Operate = undefined;
				this.Value = undefined;
				this.PlainText = undefined;
				this.Children = undefined;
			}
		}
	}
	remove() {
		if (this.parent) {
			this.parent.removeChild(this);
		} else {
			this.NodeType = NodeTypeEnum.unknow;
			this.Field = undefined;
			this.Operate = undefined;
			this.Value = undefined;
			this.PlainText = undefined;
			this.Children = undefined;
		}
	}
}
